// extracted by mini-css-extract-plugin
module.exports = {"sidebarLoader":"loader_sidebarLoader__4B287","loaderSpinner":"loader_loaderSpinner__jO1yk","spin":"loader_spin__bhLHl"};